"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkerSafeIdbBackend = void 0;
const random_1 = require("../../crypto/random");
const Store_1 = require("../store/Store");
const IdbBackend_1 = require("./IdbBackend");
const broadcastchannel_1 = require("../../util/broadcastchannel");
class WorkerSafeIdbBackend extends IdbBackend_1.IdbBackend {
    constructor(name) {
        super(name);
        WorkerSafeIdbBackend.init();
    }
    static init() {
        if (WorkerSafeIdbBackend.broadcastId === undefined) {
            WorkerSafeIdbBackend.broadcastId = new random_1.RNGImpl().randomHexString(128);
            WorkerSafeIdbBackend.broadcastChannel = new broadcastchannel_1.SafeBroadcastChannel(WorkerSafeIdbBackend.channelName);
            WorkerSafeIdbBackend.broadcastChannel.onmessage = (ev) => {
                if (ev.data.broadcastId !== undefined &&
                    ev.data.broadcastId !== WorkerSafeIdbBackend.broadcastId) {
                    IdbBackend_1.IdbBackend.fireCallbacks(ev.data.dbName, ev.data.literal);
                }
            };
        }
    }
    getBackendName() {
        return WorkerSafeIdbBackend.backendName;
    }
    async store(literal, history) {
        await super.store(literal, history);
        WorkerSafeIdbBackend.broadcastChannel.postMessage({
            broadcastId: WorkerSafeIdbBackend.broadcastId,
            dbName: this.name,
            literal: literal
        });
    }
}
exports.WorkerSafeIdbBackend = WorkerSafeIdbBackend;
WorkerSafeIdbBackend.backendName = 'worker-safe-idb';
WorkerSafeIdbBackend.channelName = 'idb-backend-trigger';
Store_1.Store.registerBackend(WorkerSafeIdbBackend.backendName, (dbName) => new WorkerSafeIdbBackend(dbName));
//# sourceMappingURL=WorkerSafeIdbBackend.js.map